export enum IconSize {
  XS = 16,
  S = 20,
  M = 24,
  L = 28,
  XL = 32
}
